<template>
  <div class="flatPickrWrapper">
    <label v-if="!!label">{{ label }}</label>
    <flatPickr v-model="dateValue" :config="config" placeholder="Select date" name="date" :allow-input="true" :disabled="disabled" />
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';

const EVENTS = { onChange: 'onChange' };

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    hasDefaultValue: {
     type: Boolean,
     default: true,
    },
    enableTime: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dateValue: this.date ? this.date : (this.hasDefaultValue ? moment().format('DD/MM/YYYY') : ''),
      config: {
        altFormat: 'd/m/Y',
        altInput: true,
        dateFormat: 'd/m/Y',
        allowInput: true,
        enableTime: this.enableTime,
        minDate: this.minDate,
        maxDate: this.maxDate,
      },
    };
  },
  watch: {
    dateValue(val) {
      this.$emit(EVENTS.onChange, val);
    },
  },
  components: {
    flatPickr,
  },
};
</script>
